import type {
  DashboardLayoutPatch,
  SaveProjectLayoutInput,
} from '@logspot-platform/platform-types';
import { api } from './api-client';
import type { Widget, DashboardConfig } from '@/types';

type Dashboard = {
  name: string;
  visible: boolean;
  description: string;
  whitelist: string[];
  primaryColor: string;
  textColor: string;
};

type UpdateOpenDashboardProps = {
  projectId: string;
  dashboard: Dashboard;
};

type UpdateWidgetProps = {
  projectId: string;
  widgets: Widget[];
};

export const DashboardService = {
  updateOpenDashboard: async ({ projectId, dashboard }: UpdateOpenDashboardProps) => {
    await api.put(`/dashboards/${projectId}/open`, dashboard);
  },

  updateWidgets: async ({ projectId, widgets }: UpdateWidgetProps) => {
    await api.put(`/dashboards/${projectId}/widgets`, { widgets });
  },

  generateLink: async ({ projectId }: { projectId: string }) => {
    await api.post(`/dashboards/${projectId}/open/link`);
  },

  saveProjectLayout: async ({
    projectId,
    input,
  }: {
    projectId: string;
    input: SaveProjectLayoutInput;
  }) => {
    await api.put(`/dashboards/${projectId}/layout`, input);
  },

  getUserLayout: async ({ projectId }: { projectId: string }) => {
    const { data } = await api.get<{ data: DashboardLayoutPatch }>(
      `/dashboards/${projectId}/layout/me`,
    );
    return data;
  },

  saveUserLayout: async ({
    projectId,
    patch,
  }: {
    projectId: string;
    patch: DashboardLayoutPatch;
  }) => {
    await api.put(`/dashboards/${projectId}/layout/me`, patch);
  },

  resetUserLayout: async ({ projectId }: { projectId: string }) => {
    await api.delete(`/dashboards/${projectId}/layout/me`);
  },

  getDashboardConfig: async ({ projectId }: { projectId: string }) => {
    const { data } = await api.get<{ data: DashboardConfig }>(`/dashboards?projectId=${projectId}`);
    return data;
  },
};
